/*global SunergoPlatform*/

const inputEvents = SunergoPlatform.inputEvents;

/**
 * Date/Time field combining when using Date/Time fieldsets.
 * @param {object} form - the form item.
 * @returns early if no date-time fieldsets.
 */
const initDateTimeFormatting = function(form) {
	const dateTimeParts = form.element.querySelectorAll('[data-date-time-fieldset-part]');
	if (!dateTimeParts || dateTimeParts.length < 1) return;

	dateTimeParts.forEach(function(fieldsetPart) {
		// Find the fieldset where the output field would be.
		const parent = fieldsetPart.closest('.sp-fieldset__fields');
		const fieldsetOutput = parent.querySelector('[data-fieldset-output]');
		const type = fieldsetOutput.dataset.fieldsetOutput;

		// Check if there is no date or time type.
		if (type != 'date' && type != 'time')
			return console.error(
				'[Form / DateTime Formatting] No date or time type in the output field.',
				parent
			);

		for (let event in inputEvents) {
			fieldsetPart.addEventListener(inputEvents[event], function() {
				let output = '';

				if (type == 'date') {
					const yearValue = parent.querySelector('[data-date-time-fieldset-part="year"]')
						.value;
					const monthValue = parent.querySelector(
						'[data-date-time-fieldset-part="month"]'
					).value;
					const dayValue = parent.querySelector('[data-date-time-fieldset-part="day"]')
						.value;

					// Return blank value if no values.
					if (!yearValue || !monthValue || !dayValue) output = '';
					else {
						output = yearValue.toString();
						output += '-';

						const month = monthValue.toString();
						if (month.length == 1) output += '0';
						output += month;

						output += '-';
						const day = dayValue.toString();
						if (day.length == 1) output += '0';
						output += day;
					}
				} else if (type == 'time') {
					const pm =
						parent.querySelector('[data-date-time-fieldset-part="ampm"]').value == 'pm';
					const hourValue = parent.querySelector('[data-date-time-fieldset-part="hour"]')
						.value;
					const minuteValue = parent.querySelector(
						'[data-date-time-fieldset-part="minute"]'
					).value;

					// Return blank value if no values.
					if (!hourValue || !minuteValue) output = '';
					else {
						let hour = parseInt(hourValue) % 12;
						if (pm) hour = hour + 12;
						hour = hour.toString();
						if (hour.length == 1) output += '0';
						output += hour;

						output += ':';
						const minute = minuteValue.toString();
						if (minute.length == 1) output += '0';
						output += minute;
					}
				}

				// Update output value and emit change.
				fieldsetOutput.value = output;
				fieldsetOutput.dispatchEvent(new Event('spInputChange'));
			});
		}

		// Normalize and pad minute value.
		if (type == 'time' && fieldsetPart.dataset.dateTimeFieldsetPart == 'minute') {
			fieldsetPart.addEventListener('blur', function(e) {
				const value = fieldsetPart.value.toString();
				if (!value) return;
				let minute = parseInt(value, 10);
				if (isNaN(minute)) minute = 0;
				if (minute < 0) minute = 0;
				if (minute > 59) minute = 59;
				fieldsetPart.value = minute < 10 ? '0' + minute : minute.toString();
				fieldsetPart.dispatchEvent(new Event('input'));
			});
		}
	});
};

export default initDateTimeFormatting;